import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import draftToMarkdown from 'draftjs-to-markdown';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';

import './WysiwygEditor.style.less';

export default class WysiwygEditor extends PureComponent {
  constructor(props) {
    super(props);

    const contentBlock = htmlToDraft(props.initialValue || '');
    let editorState;
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks,
      );
      editorState = EditorState.createWithContent(contentState);
    }
    this.state = {
      editorState,
    };
  }

  onEditorStateChange = editorState => {
    const content = draftToMarkdown(
      convertToRaw(editorState.getCurrentContent()),
    ).trim();
    const separateContent = content.split(';">');
    let isEmpty = false;

    if (
      (separateContent.length === 1 && separateContent[0].length === 0) ||
      (separateContent.length > 1 && separateContent[1].length === 7)
    ) {
      isEmpty = true;
    }

    const stringContent = escape(
      draftToHtml(convertToRaw(editorState.getCurrentContent())),
    );
    this.props.onChange(isEmpty, stringContent, editorState);

    this.setState({
      editorState,
    });
  };

  render() {
    const { editorState } = this.state;
    const { errorText } = this.props;
    return (
      <div id="text-wysiwyg">
        <Editor
          editorState={editorState}
          toolbar={toolbar}
          wrapperClassName="text-wysiwyg-wrapper"
          editorClassName={errorText ? 'text-editor error' : 'text-editor'}
          onEditorStateChange={this.onEditorStateChange}
          stripPastedStyles="true"
        ></Editor>
        <span className="errorText">{errorText}</span>
      </div>
    );
  }
}

const toolbar = {
  options: [
    'inline',
    'blockType',
    'fontSize',
    'fontFamily',
    'list',
    'textAlign',
    'colorPicker',
    'remove',
    'history',
  ],
  inline: {
    inDropdown: false,
    options: [
      'bold',
      'italic',
      'underline',
      'strikethrough',
      'superscript',
      'subscript',
    ],
  },
  blockType: {
    inDropdown: true,
    options: [
      'Normal',
      'H1',
      'H2',
      'H3',
      'H4',
      'H5',
      'H6',
      'Blockquote',
      'Code',
    ],
  },
  fontSize: {
    options: [8, 9, 10, 11, 12, 14, 16, 18, 20, 24, 30, 36, 48, 60, 72, 96],
  },
  fontFamily: {
    options: ['Native Font', 'Open Sans', 'Courier New', 'Times New Roman'],
  },
  list: {
    inDropdown: false,
    options: ['unordered', 'ordered', 'indent', 'outdent'],
  },
  textAlign: {
    inDropdown: false,
    options: ['left', 'center', 'right', 'justify'],
  },
};

WysiwygEditor.propTypes = {
  onChange: PropTypes.func,
  initialValue: PropTypes.string,
  errorText: PropTypes.string,
};
